import React, { Component } from 'react';

/* 개발담당:양유빈
 * 화면기능:로딩 콤퍼넌트
 * 세부설명:
*/

export class Loading extends Component {
    static displayName = Loading.name;

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    //초기화
    componentDidMount() {
    }
    
    render() {
        if (this.props.Visible === undefined) {
            return false;
        }
        else {
            if (this.props.Visible === true) {
                return (
                    <div className="loading_wrap">
                        <div className="dot-wave">
                            <div className="dot-wave__dot"></div>
                            <div className="dot-wave__dot"></div>
                            <div className="dot-wave__dot"></div>
                            <div className="dot-wave__dot"></div>
                        </div>
                    </div>
                );
            }
            
        }
       
    }
}
